"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.tabletStyles = exports.phoneStyles = exports.desktopStyles = void 0;
require("./responsiveSpacing.css");
/**
 * DO NOT MODIFY
 * Generated from scripts/codegen/main.ts
 */

const desktopStyles = {
  padding: {
    all: {
      0: "cds-0-_1acbvpz",
      1: "cds-1-_b2wzas",
      2: "cds-2-_1l2046v",
      3: "cds-3-_1b1j28n",
      4: "cds-4-_ogc320",
      5: "cds-5-_1t1fqjz",
      6: "cds-6-_xlcl",
      7: "cds-7-_1qd0kax",
      8: "cds-8-_32s066",
      9: "cds-9-_tx97ki",
      10: "cds-10-_7jllz1",
      0.5: "cds-0_5-_xv260o",
      1.5: "cds-1_5-_13zpem7"
    },
    top: {
      0: "cds-0-_c7bt3i",
      1: "cds-1-_ejs2dh",
      2: "cds-2-_1ww4fvs",
      3: "cds-3-_tuz1vp",
      4: "cds-4-_1p8rdij",
      5: "cds-5-_17gotp6",
      6: "cds-6-_pli9kl",
      7: "cds-7-_5b0ixt",
      8: "cds-8-_1ffyq2u",
      9: "cds-9-_zv9pr4",
      10: "cds-10-_1t3lo9e",
      0.5: "cds-0_5-_1c0hbfc",
      1.5: "cds-1_5-_1gc2phe"
    },
    bottom: {
      0: "cds-0-_1oyibs5",
      1: "cds-1-_1c8dsza",
      2: "cds-2-_13fada3",
      3: "cds-3-_vwpz1t",
      4: "cds-4-_19rohzt",
      5: "cds-5-_1rtg3sz",
      6: "cds-6-_1cxm0sa",
      7: "cds-7-_1verjup",
      8: "cds-8-_nra3gc",
      9: "cds-9-_hqnshd",
      10: "cds-10-_17wisxn",
      0.5: "cds-0_5-_lqkrqm",
      1.5: "cds-1_5-_e1wf4x"
    },
    left: {
      0: "cds-0-_1sbduhv",
      1: "cds-1-_ijnni2",
      2: "cds-2-_wzmas2",
      3: "cds-3-_djysov",
      4: "cds-4-_1bbzrm8",
      5: "cds-5-_7kmmbc",
      6: "cds-6-_lsmhjw",
      7: "cds-7-_1ac420c",
      8: "cds-8-_1m96vuo",
      9: "cds-9-_58lfhw",
      10: "cds-10-_1s82i3n",
      0.5: "cds-0_5-_1t0llfo",
      1.5: "cds-1_5-_1jz5qfr"
    },
    right: {
      0: "cds-0-_1jn5pr0",
      1: "cds-1-_bbolly",
      2: "cds-2-_1r89dtb",
      3: "cds-3-_19x0vp7",
      4: "cds-4-_ienqbu",
      5: "cds-5-_1wl3y26",
      6: "cds-6-_a2xcju",
      7: "cds-7-_1wqiqzy",
      8: "cds-8-_esj15t",
      9: "cds-9-_1vdanb2",
      10: "cds-10-_19w4da2",
      0.5: "cds-0_5-_18ki258",
      1.5: "cds-1_5-_3dm2zm"
    }
  },
  margin: {
    all: {
      0: "cds-0-_14eposo",
      1: "cds-1-_pr5hrz",
      2: "cds-2-_1niakhc",
      3: "cds-3-_yt3olx",
      4: "cds-4-_6oj4oe",
      5: "cds-5-_17o5wkb",
      6: "cds-6-_1md2nm7",
      7: "cds-7-_lgqy8a",
      8: "cds-8-_1kttvu2",
      9: "cds-9-_1he5g69",
      10: "cds-10-_1bjferc",
      0.5: "cds-0_5-_38nh7z",
      1.5: "cds-1_5-_9v4956"
    },
    top: {
      0: "cds-0-_o2fiwt",
      1: "cds-1-_25zxs0",
      2: "cds-2-_12ky5n4",
      3: "cds-3-_1lx0qdq",
      4: "cds-4-_p8qy8j",
      5: "cds-5-_1yykoeh",
      6: "cds-6-_34d7qu",
      7: "cds-7-_11ds23x",
      8: "cds-8-_nphmg9",
      9: "cds-9-_1krje00",
      10: "cds-10-_1rzwan2",
      0.5: "cds-0_5-_1hvn5mk",
      1.5: "cds-1_5-_11nr3xo"
    },
    bottom: {
      0: "cds-0-_mpmmbl",
      1: "cds-1-_1actxs1",
      2: "cds-2-_yiss1p",
      3: "cds-3-_4wm1gp",
      4: "cds-4-_1k6txlu",
      5: "cds-5-_mm4h05",
      6: "cds-6-_gug4u",
      7: "cds-7-_qsfz1j",
      8: "cds-8-_i4e85p",
      9: "cds-9-_1i251a3",
      10: "cds-10-_1vblbil",
      0.5: "cds-0_5-_ln4l8j",
      1.5: "cds-1_5-_fpkghz"
    },
    left: {
      0: "cds-0-_1018ibx",
      1: "cds-1-_e2fs98",
      2: "cds-2-_12pz5oc",
      3: "cds-3-_im6rzf",
      4: "cds-4-_15vajdo",
      5: "cds-5-_jvgh1n",
      6: "cds-6-_1lnjmw9",
      7: "cds-7-_1xawbjt",
      8: "cds-8-_118r59b",
      9: "cds-9-_7a6rvi",
      10: "cds-10-_ildpr3",
      0.5: "cds-0_5-_1oug85j",
      1.5: "cds-1_5-_1f839h3"
    },
    right: {
      0: "cds-0-_1e3hzdk",
      1: "cds-1-_1bssd0w",
      2: "cds-2-_y88o7d",
      3: "cds-3-_inescu",
      4: "cds-4-_1me6ub6",
      5: "cds-5-_1scq2dp",
      6: "cds-6-_78opiy",
      7: "cds-7-_ypvuo3",
      8: "cds-8-_s2c2ia",
      9: "cds-9-_8iv5q9",
      10: "cds-10-_zr3o0s",
      0.5: "cds-0_5-_1uf0ahq",
      1.5: "cds-1_5-_s7rnln"
    }
  }
};
exports.desktopStyles = desktopStyles;
const tabletStyles = {
  padding: {
    all: {
      0: "cds-0-_dv53ho",
      1: "cds-1-_q3un3v",
      2: "cds-2-_1ccgzua",
      3: "cds-3-_6zuzzd",
      4: "cds-4-_ep6qdk",
      5: "cds-5-_10xrjsm",
      6: "cds-6-_1mzhr7",
      7: "cds-7-_1fjj868",
      8: "cds-8-_180t91o",
      9: "cds-9-_uc1eeq",
      10: "cds-10-_rbnrj2",
      0.5: "cds-0_5-_nlh06s",
      1.5: "cds-1_5-_p1wea7"
    },
    top: {
      0: "cds-0-_10q7r8s",
      1: "cds-1-_1nn3h9r",
      2: "cds-2-_1rj7sz9",
      3: "cds-3-_1fo8ki6",
      4: "cds-4-_mjtmgu",
      5: "cds-5-_o074f6",
      6: "cds-6-_1qu0bk9",
      7: "cds-7-_12zedwa",
      8: "cds-8-_umequd",
      9: "cds-9-_m0eloe",
      10: "cds-10-_3zs4qu",
      0.5: "cds-0_5-_1i80uho",
      1.5: "cds-1_5-_1cebome"
    },
    bottom: {
      0: "cds-0-_141a4f5",
      1: "cds-1-_izgph2",
      2: "cds-2-_12afyca",
      3: "cds-3-_1f73od0",
      4: "cds-4-_12193dw",
      5: "cds-5-_2do2sh",
      6: "cds-6-_bifpol",
      7: "cds-7-_1qfpg55",
      8: "cds-8-_1sxy46r",
      9: "cds-9-_yhey5z",
      10: "cds-10-_hbi895",
      0.5: "cds-0_5-_10sxo2l",
      1.5: "cds-1_5-_isbbol"
    },
    left: {
      0: "cds-0-_1j01s1c",
      1: "cds-1-_1m93h8",
      2: "cds-2-_19f3gi4",
      3: "cds-3-_7zb9pe",
      4: "cds-4-_s4d7zj",
      5: "cds-5-_1xd0wj2",
      6: "cds-6-_ngzvb0",
      7: "cds-7-_sk9xyf",
      8: "cds-8-_ce85ut",
      9: "cds-9-_3tp2cn",
      10: "cds-10-_hel3x4",
      0.5: "cds-0_5-_10wn62e",
      1.5: "cds-1_5-_1bwdu25"
    },
    right: {
      0: "cds-0-_1mcukzo",
      1: "cds-1-_1oi9sn1",
      2: "cds-2-_b5kyez",
      3: "cds-3-_6e1890",
      4: "cds-4-_d2uao5",
      5: "cds-5-_g3hqf0",
      6: "cds-6-_16fm6wf",
      7: "cds-7-_18kwnxt",
      8: "cds-8-_13nrc5j",
      9: "cds-9-_1r93n0e",
      10: "cds-10-_6n2iqc",
      0.5: "cds-0_5-_16kwbe4",
      1.5: "cds-1_5-_1bcbs54"
    }
  },
  margin: {
    all: {
      0: "cds-0-_1pii2jb",
      1: "cds-1-_k4k12w",
      2: "cds-2-_14xnigg",
      3: "cds-3-_13jy8qs",
      4: "cds-4-_1kra0b0",
      5: "cds-5-_15u9qhd",
      6: "cds-6-_xbxum8",
      7: "cds-7-_3w4hmd",
      8: "cds-8-_7otfd",
      9: "cds-9-_83ek8j",
      10: "cds-10-_13ihp9s",
      0.5: "cds-0_5-_1ovyl17",
      1.5: "cds-1_5-_1t5ket0"
    },
    top: {
      0: "cds-0-_15lgh99",
      1: "cds-1-_1kx2552",
      2: "cds-2-_4j19h4",
      3: "cds-3-_1gniwym",
      4: "cds-4-_pgk0w9",
      5: "cds-5-_s4pcap",
      6: "cds-6-_1rtchab",
      7: "cds-7-_w2ygvp",
      8: "cds-8-_1nmv67o",
      9: "cds-9-_stuf3c",
      10: "cds-10-_1jomr0e",
      0.5: "cds-0_5-_8ldc9x",
      1.5: "cds-1_5-_382nlk"
    },
    bottom: {
      0: "cds-0-_1mil1ys",
      1: "cds-1-_b32itu",
      2: "cds-2-_18uvjug",
      3: "cds-3-_ygcw3",
      4: "cds-4-_c48s5h",
      5: "cds-5-_16j1ms9",
      6: "cds-6-_7je1i3",
      7: "cds-7-_1u6xl7d",
      8: "cds-8-_1yvoqc7",
      9: "cds-9-_mv71q3",
      10: "cds-10-_1p0cfmp",
      0.5: "cds-0_5-_147aeoj",
      1.5: "cds-1_5-_1ulk76n"
    },
    left: {
      0: "cds-0-_1vf65pt",
      1: "cds-1-_1q5zdnc",
      2: "cds-2-_hj43ok",
      3: "cds-3-_1wgaxy0",
      4: "cds-4-_v97xgk",
      5: "cds-5-_1y3ddwc",
      6: "cds-6-_z1v9ff",
      7: "cds-7-_mo8did",
      8: "cds-8-_8ejw7q",
      9: "cds-9-_1mnjtm8",
      10: "cds-10-_oi79qo",
      0.5: "cds-0_5-_1wttmuu",
      1.5: "cds-1_5-_j4j8jj"
    },
    right: {
      0: "cds-0-_1ojnxv9",
      1: "cds-1-_8yh72b",
      2: "cds-2-_kygyqj",
      3: "cds-3-_l4wids",
      4: "cds-4-_k03ve5",
      5: "cds-5-_3lb8tb",
      6: "cds-6-_2adojx",
      7: "cds-7-_1hcq0fw",
      8: "cds-8-_oi4q0y",
      9: "cds-9-_4jfspu",
      10: "cds-10-_v5945u",
      0.5: "cds-0_5-_ujbdp2",
      1.5: "cds-1_5-_1x5w98q"
    }
  }
};
exports.tabletStyles = tabletStyles;
const phoneStyles = {
  padding: {
    all: {
      0: "cds-0-_11pjh8t",
      1: "cds-1-_1s90tv8",
      2: "cds-2-_1pymnsd",
      3: "cds-3-_516c3l",
      4: "cds-4-_o0h7l5",
      5: "cds-5-_1241zd9",
      6: "cds-6-_qzstru",
      7: "cds-7-_xj8zq6",
      8: "cds-8-_1o2ronq",
      9: "cds-9-_1y87ylf",
      10: "cds-10-_1w1ink7",
      0.5: "cds-0_5-_okb2li",
      1.5: "cds-1_5-_1al6fw2"
    },
    top: {
      0: "cds-0-_je78ut",
      1: "cds-1-_saahde",
      2: "cds-2-_1kcz1cb",
      3: "cds-3-_lpku4f",
      4: "cds-4-_twnbfv",
      5: "cds-5-_7porft",
      6: "cds-6-_pfkgl7",
      7: "cds-7-_133cyvm",
      8: "cds-8-_19mpit5",
      9: "cds-9-_1k18yzy",
      10: "cds-10-_xv2bkl",
      0.5: "cds-0_5-_1wn9qt2",
      1.5: "cds-1_5-_1ddgolw"
    },
    bottom: {
      0: "cds-0-_8di67o",
      1: "cds-1-_6c3m89",
      2: "cds-2-_ghid3g",
      3: "cds-3-_1t3h2lk",
      4: "cds-4-_100uoag",
      5: "cds-5-_tm5zlf",
      6: "cds-6-_77mbp4",
      7: "cds-7-_1f4wnvl",
      8: "cds-8-_znd93b",
      9: "cds-9-_ukb6p1",
      10: "cds-10-_1l6475i",
      0.5: "cds-0_5-_6mndlf",
      1.5: "cds-1_5-_x8hseb"
    },
    left: {
      0: "cds-0-_1r7asm2",
      1: "cds-1-_1n6yhyt",
      2: "cds-2-_1fd9dlx",
      3: "cds-3-_1bhqsxp",
      4: "cds-4-_1vkbc4y",
      5: "cds-5-_hda4y0",
      6: "cds-6-_1805wfk",
      7: "cds-7-_16n4s0n",
      8: "cds-8-_1xa0lsc",
      9: "cds-9-_68262u",
      10: "cds-10-_1idn3rt",
      0.5: "cds-0_5-_90vnii",
      1.5: "cds-1_5-_93kzix"
    },
    right: {
      0: "cds-0-_tivn5z",
      1: "cds-1-_1djleyr",
      2: "cds-2-_116h5jv",
      3: "cds-3-_1llo9p5",
      4: "cds-4-_113sywy",
      5: "cds-5-_am88s6",
      6: "cds-6-_27ma2f",
      7: "cds-7-_1gqqa00",
      8: "cds-8-_1uqtyex",
      9: "cds-9-_dffzhh",
      10: "cds-10-_namsbe",
      0.5: "cds-0_5-_1lr4d0x",
      1.5: "cds-1_5-_18o14g"
    }
  },
  margin: {
    all: {
      0: "cds-0-_1s8jerx",
      1: "cds-1-_1r1t9bf",
      2: "cds-2-_niqgpd",
      3: "cds-3-_eq4vlw",
      4: "cds-4-_7wpv1n",
      5: "cds-5-_1wu895r",
      6: "cds-6-_r14js9",
      7: "cds-7-_glj8ik",
      8: "cds-8-_medayd",
      9: "cds-9-_wsh1jp",
      10: "cds-10-_1gyidm1",
      0.5: "cds-0_5-_1jk6ecn",
      1.5: "cds-1_5-_7vbuoq"
    },
    top: {
      0: "cds-0-_1gnxd4n",
      1: "cds-1-_1j9q57a",
      2: "cds-2-_13pgfog",
      3: "cds-3-_16dj99p",
      4: "cds-4-_1jk5y57",
      5: "cds-5-_t5n7if",
      6: "cds-6-_1iixf00",
      7: "cds-7-_1rrg8is",
      8: "cds-8-_c4wv27",
      9: "cds-9-_y5hsrk",
      10: "cds-10-_zh6yen",
      0.5: "cds-0_5-_oab6oi",
      1.5: "cds-1_5-_17sxydv"
    },
    bottom: {
      0: "cds-0-_1fy3guc",
      1: "cds-1-_143wn8m",
      2: "cds-2-_1kr1jkl",
      3: "cds-3-_1duh94w",
      4: "cds-4-_fh80xx",
      5: "cds-5-_177yv4m",
      6: "cds-6-_nvkke5",
      7: "cds-7-_75ow8n",
      8: "cds-8-_9300um",
      9: "cds-9-_3hbosx",
      10: "cds-10-_d3if8m",
      0.5: "cds-0_5-_1m1q62n",
      1.5: "cds-1_5-_1by7hh9"
    },
    left: {
      0: "cds-0-_194j1b5",
      1: "cds-1-_1t73hwe",
      2: "cds-2-_1cjjjdf",
      3: "cds-3-_64hw7s",
      4: "cds-4-_q6yy89",
      5: "cds-5-_1w4rjpy",
      6: "cds-6-_m9daon",
      7: "cds-7-_18dcekc",
      8: "cds-8-_qyji5c",
      9: "cds-9-_12y7xyy",
      10: "cds-10-_768szb",
      0.5: "cds-0_5-_1fjr8pm",
      1.5: "cds-1_5-_1tt6xla"
    },
    right: {
      0: "cds-0-_bf7f9r",
      1: "cds-1-_6sdvrg",
      2: "cds-2-_6xdwas",
      3: "cds-3-_6kxkn0",
      4: "cds-4-_mm9tss",
      5: "cds-5-_1xcgcw5",
      6: "cds-6-_hw1gwh",
      7: "cds-7-_8sfkzb",
      8: "cds-8-_1e82ub4",
      9: "cds-9-_14yuss3",
      10: "cds-10-_1frxax",
      0.5: "cds-0_5-_1iq3kl5",
      1.5: "cds-1_5-_30n02c"
    }
  }
};
exports.phoneStyles = phoneStyles;